import React from "react";
import { message } from "antd";
import { isTrue } from "Utils/filter";
import { useAtomValue } from "jotai";
import { loginModeAtom } from "Stores/SettingsStore";
import { useMount } from "react-use";
import { login } from "API/auth";
import { errorMessage } from "Utils/useRequest";
import useRequestFn from "Utils/useRequestFn";
import { FormFields } from "../Components/LoginComponent/components/AccountMode";
import LoginComponent from "../Components/LoginComponent";

export default function LoginConsole() {
    const loginMode = useAtomValue(loginModeAtom);

    useMount(() => {
        localStorage.clear();
    });

    const [doLogin] = useRequestFn(async (data: FormFields) => {
        const { username, password, code } = data;

        try {
            await login("/student/dynamicLogin", username, password, code);
            window.location.href = "/";
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    if (!isTrue(loginMode.dynamicCertLogin)) {
        return <div>后台禁止了动态码登录</div>;
    }

    return <LoginComponent onSubmit={doLogin} />;
}
